(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire72ff"];
var parcelRegister = parcelRequire.register;
parcelRegister("hDT0L", function(module, exports) {

$parcel$export(module.exports, "startRecording", function () { return $cd80c04915ce82cc$export$9be9afda50c84681; });

var $d5Gi4 = parcelRequire("d5Gi4");
var $iwN6C = parcelRequire("iwN6C");
var $i60I1 = parcelRequire("i60I1");
parcelRequire("bjWjO");
var $9zxSs = parcelRequire("9zxSs");
parcelRequire("lDilv");
var $5RW20 = parcelRequire("5RW20");
var $hdBNW = parcelRequire("hdBNW");

var $kJtyc = parcelRequire("kJtyc");
function $cd80c04915ce82cc$export$9be9afda50c84681(lifeCycle, configuration, sessionManager, viewHistory, encoder, telemetry, httpRequest) {
    const cleanupTasks = [];
    const reportError = (error)=>{
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        (0, $d5Gi4.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
    const replayRequest = httpRequest || (0, $i60I1.createHttpRequest)([
        configuration.sessionReplayEndpointBuilder
    ], (0, $5RW20.SEGMENT_BYTES_LIMIT), reportError);
    let addRecord;
    if (!(0, $iwN6C.canUseEventBridge)()) {
        const segmentCollection = (0, $5RW20.startSegmentCollection)(lifeCycle, configuration, sessionManager, viewHistory, replayRequest, encoder);
        addRecord = segmentCollection.addRecord;
        cleanupTasks.push(segmentCollection.stop);
        const segmentTelemetry = (0, $hdBNW.startSegmentTelemetry)(configuration, telemetry, replayRequest.observable);
        cleanupTasks.push(segmentTelemetry.stop);
    } else ({ addRecord: addRecord } = (0, $kJtyc.startRecordBridge)(viewHistory));
    const { stop: stopRecording } = (0, $9zxSs.record)({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
        viewHistory: viewHistory
    });
    cleanupTasks.push(stopRecording);
    return {
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        }
    };
}

});
parcelRegister("bjWjO", function(module, exports) {

$parcel$export(module.exports, "record", function () { return (parcelRequire("9zxSs")).record; });
$parcel$export(module.exports, "createSerializationStats", function () { return (parcelRequire("1vkMB")).createSerializationStats; });
$parcel$export(module.exports, "aggregateSerializationStats", function () { return (parcelRequire("1vkMB")).aggregateSerializationStats; });

var $9zxSs = parcelRequire("9zxSs");
parcelRequire("1ExgI");
var $1vkMB = parcelRequire("1vkMB");

var $dX2go = parcelRequire("dX2go");

});
parcelRegister("9zxSs", function(module, exports) {

$parcel$export(module.exports, "record", function () { return $6f81a9473046523e$export$e5185e241753e543; });

var $lWJ4T = parcelRequire("lWJ4T");

var $jVAvF = parcelRequire("jVAvF");
parcelRequire("1khYs");
var $gkUlb = parcelRequire("gkUlb");
var $eJj00 = parcelRequire("eJj00");
var $jw2rs = parcelRequire("jw2rs");
var $8TObS = parcelRequire("8TObS");
var $5OYfh = parcelRequire("5OYfh");
var $7PKCk = parcelRequire("7PKCk");
var $eeW8V = parcelRequire("eeW8V");
var $aZc9X = parcelRequire("aZc9X");
var $3EzVd = parcelRequire("3EzVd");
var $42UAy = parcelRequire("42UAy");
var $cfOT6 = parcelRequire("cfOT6");

var $dX2go = parcelRequire("dX2go");

var $lnrcK = parcelRequire("lnrcK");

var $12bW4 = parcelRequire("12bW4");

var $eabLN = parcelRequire("eabLN");
function $6f81a9473046523e$export$e5185e241753e543(options) {
    const { emit: emit, configuration: configuration, lifeCycle: lifeCycle } = options;
    // runtime checks for user options
    if (!emit) throw new Error("emit function is required");
    const emitAndComputeStats = (record, stats)=>{
        emit(record, stats);
        (0, $lWJ4T.sendToExtension)("record", {
            record: record
        });
        const view = options.viewHistory.findView();
        $jVAvF.addRecord(view.id);
    };
    const elementsScrollPositions = (0, $dX2go.createElementsScrollPositions)();
    const shadowRootsController = (0, $lnrcK.initShadowRootsController)(configuration, emitAndComputeStats, elementsScrollPositions);
    const { stop: stopFullSnapshots } = (0, $12bW4.startFullSnapshots)(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, emitAndComputeStats);
    function flushMutations() {
        shadowRootsController.flush();
        mutationTracker.flush();
    }
    const recordIds = (0, $eabLN.initRecordIds)();
    const mutationTracker = (0, $eeW8V.trackMutation)(emitAndComputeStats, configuration, shadowRootsController, document);
    const trackers = [
        mutationTracker,
        (0, $7PKCk.trackMove)(configuration, emitAndComputeStats),
        (0, $5OYfh.trackMouseInteraction)(configuration, emitAndComputeStats, recordIds),
        (0, $aZc9X.trackScroll)(configuration, emitAndComputeStats, elementsScrollPositions, document),
        (0, $cfOT6.trackViewportResize)(configuration, emitAndComputeStats),
        (0, $jw2rs.trackInput)(configuration, emitAndComputeStats),
        (0, $8TObS.trackMediaInteraction)(configuration, emitAndComputeStats),
        (0, $3EzVd.trackStyleSheet)(emitAndComputeStats),
        (0, $gkUlb.trackFocus)(configuration, emitAndComputeStats),
        (0, $cfOT6.trackVisualViewportResize)(configuration, emitAndComputeStats),
        (0, $eJj00.trackFrustration)(lifeCycle, emitAndComputeStats, recordIds),
        (0, $42UAy.trackViewEnd)(lifeCycle, (viewEndRecord)=>{
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        })
    ];
    return {
        stop: ()=>{
            shadowRootsController.stop();
            trackers.forEach((tracker)=>tracker.stop());
            stopFullSnapshots();
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController
    };
}

});
parcelRegister("1khYs", function(module, exports) {

$parcel$export(module.exports, "trackMove", function () { return (parcelRequire("7PKCk")).trackMove; });
$parcel$export(module.exports, "trackMouseInteraction", function () { return (parcelRequire("5OYfh")).trackMouseInteraction; });
$parcel$export(module.exports, "trackScroll", function () { return (parcelRequire("aZc9X")).trackScroll; });
$parcel$export(module.exports, "trackViewportResize", function () { return (parcelRequire("cfOT6")).trackViewportResize; });
$parcel$export(module.exports, "trackVisualViewportResize", function () { return (parcelRequire("cfOT6")).trackVisualViewportResize; });
$parcel$export(module.exports, "trackMediaInteraction", function () { return (parcelRequire("8TObS")).trackMediaInteraction; });
$parcel$export(module.exports, "trackStyleSheet", function () { return (parcelRequire("3EzVd")).trackStyleSheet; });
$parcel$export(module.exports, "trackFocus", function () { return (parcelRequire("gkUlb")).trackFocus; });
$parcel$export(module.exports, "trackFrustration", function () { return (parcelRequire("eJj00")).trackFrustration; });
$parcel$export(module.exports, "trackViewEnd", function () { return (parcelRequire("42UAy")).trackViewEnd; });
$parcel$export(module.exports, "trackInput", function () { return (parcelRequire("jw2rs")).trackInput; });
$parcel$export(module.exports, "trackMutation", function () { return (parcelRequire("eeW8V")).trackMutation; });

var $7PKCk = parcelRequire("7PKCk");

var $5OYfh = parcelRequire("5OYfh");

var $aZc9X = parcelRequire("aZc9X");

var $cfOT6 = parcelRequire("cfOT6");

var $8TObS = parcelRequire("8TObS");

var $3EzVd = parcelRequire("3EzVd");

var $gkUlb = parcelRequire("gkUlb");

var $eJj00 = parcelRequire("eJj00");

var $42UAy = parcelRequire("42UAy");

var $jw2rs = parcelRequire("jw2rs");

var $eeW8V = parcelRequire("eeW8V");

});
parcelRegister("7PKCk", function(module, exports) {

$parcel$export(module.exports, "trackMove", function () { return $5b41750626f6d242$export$9dc14b2d5956f1cb; });
$parcel$export(module.exports, "tryToComputeCoordinates", function () { return $5b41750626f6d242$export$3267b4eb1312c189; });

var $la2h1 = parcelRequire("la2h1");
var $d5Gi4 = parcelRequire("d5Gi4");
var $k40sw = parcelRequire("k40sw");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $7JhBz = parcelRequire("7JhBz");

var $jUJAc = parcelRequire("jUJAc");

var $jU43l = parcelRequire("jU43l");
const $5b41750626f6d242$var$MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function $5b41750626f6d242$export$9dc14b2d5956f1cb(configuration, moveCb) {
    const { throttled: updatePosition, cancel: cancelThrottle } = (0, $k40sw.throttle)((event)=>{
        const target = (0, $7JhBz.getEventTarget)(event);
        if ((0, $5cMnH.hasSerializedNode)(target)) {
            const coordinates = $5b41750626f6d242$export$3267b4eb1312c189(event);
            if (!coordinates) return;
            const position = {
                id: (0, $5cMnH.getSerializedNodeId)(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y
            };
            moveCb((0, $jU43l.assembleIncrementalSnapshot)((0, $7JhBz.isTouchEvent)(event) ? (0, $tBEq8.IncrementalSource).TouchMove : (0, $tBEq8.IncrementalSource).MouseMove, {
                positions: [
                    position
                ]
            }));
        }
    }, $5b41750626f6d242$var$MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false
    });
    const { stop: removeListener } = (0, $la2h1.addEventListeners)(configuration, document, [
        "mousemove" /* DOM_EVENT.MOUSE_MOVE */ ,
        "touchmove" /* DOM_EVENT.TOUCH_MOVE */ 
    ], updatePosition, {
        capture: true,
        passive: true
    });
    return {
        stop: ()=>{
            removeListener();
            cancelThrottle();
        }
    };
}
function $5b41750626f6d242$export$3267b4eb1312c189(event) {
    let { clientX: x, clientY: y } = (0, $7JhBz.isTouchEvent)(event) ? event.changedTouches[0] : event;
    if (window.visualViewport) {
        const { visualViewportX: visualViewportX, visualViewportY: visualViewportY } = (0, $jUJAc.convertMouseEventToLayoutCoordinates)(x, y);
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) (0, $d5Gi4.addTelemetryDebug)("mouse/touch event without x/y");
        return undefined;
    }
    return {
        x: x,
        y: y
    };
}

});
parcelRegister("1ExgI", function(module, exports) {

$parcel$export(module.exports, "getElementInputValue", function () { return (parcelRequire("5cMnH")).getElementInputValue; });
$parcel$export(module.exports, "getSerializedNodeId", function () { return (parcelRequire("5cMnH")).getSerializedNodeId; });
$parcel$export(module.exports, "hasSerializedNode", function () { return (parcelRequire("5cMnH")).hasSerializedNode; });
$parcel$export(module.exports, "nodeAndAncestorsHaveSerializedNode", function () { return (parcelRequire("5cMnH")).nodeAndAncestorsHaveSerializedNode; });
$parcel$export(module.exports, "serializeDocument", function () { return (parcelRequire("b3Dw0")).serializeDocument; });
$parcel$export(module.exports, "serializeNodeWithId", function () { return (parcelRequire("fti8b")).serializeNodeWithId; });
$parcel$export(module.exports, "serializeAttribute", function () { return (parcelRequire("eERII")).serializeAttribute; });
$parcel$export(module.exports, "createSerializationStats", function () { return (parcelRequire("1vkMB")).createSerializationStats; });
$parcel$export(module.exports, "updateSerializationStats", function () { return (parcelRequire("1vkMB")).updateSerializationStats; });
$parcel$export(module.exports, "aggregateSerializationStats", function () { return (parcelRequire("1vkMB")).aggregateSerializationStats; });

var $5cMnH = parcelRequire("5cMnH");

var $b3Dw0 = parcelRequire("b3Dw0");

var $fti8b = parcelRequire("fti8b");

var $eERII = parcelRequire("eERII");

var $1vkMB = parcelRequire("1vkMB");

});
parcelRegister("5cMnH", function(module, exports) {

$parcel$export(module.exports, "hasSerializedNode", function () { return $3ca39a3e74eedadd$export$baab016255f94f54; });
$parcel$export(module.exports, "nodeAndAncestorsHaveSerializedNode", function () { return $3ca39a3e74eedadd$export$267b85776945782d; });
$parcel$export(module.exports, "getSerializedNodeId", function () { return $3ca39a3e74eedadd$export$1cdf184f338e4a7b; });
$parcel$export(module.exports, "setSerializedNodeId", function () { return $3ca39a3e74eedadd$export$8fed415004211d23; });
$parcel$export(module.exports, "getElementInputValue", function () { return $3ca39a3e74eedadd$export$9a014d2606da64f5; });
$parcel$export(module.exports, "switchToAbsoluteUrl", function () { return $3ca39a3e74eedadd$export$f7bc20cfc5b360e4; });
$parcel$export(module.exports, "getValidTagName", function () { return $3ca39a3e74eedadd$export$b3a58098b2e64dd6; });
$parcel$export(module.exports, "censoredImageForSize", function () { return $3ca39a3e74eedadd$export$370a3fb2c1e85509; });

var $lCqoI = parcelRequire("lCqoI");

var $82USe = parcelRequire("82USe");
const $3ca39a3e74eedadd$var$serializedNodeIds = new WeakMap();
function $3ca39a3e74eedadd$export$baab016255f94f54(node) {
    return $3ca39a3e74eedadd$var$serializedNodeIds.has(node);
}
function $3ca39a3e74eedadd$export$267b85776945782d(node) {
    let current = node;
    while(current){
        if (!$3ca39a3e74eedadd$export$baab016255f94f54(current) && !(0, $82USe.isNodeShadowRoot)(current)) return false;
        current = (0, $82USe.getParentNode)(current);
    }
    return true;
}
function $3ca39a3e74eedadd$export$1cdf184f338e4a7b(node) {
    return $3ca39a3e74eedadd$var$serializedNodeIds.get(node);
}
function $3ca39a3e74eedadd$export$8fed415004211d23(node, serializeNodeId) {
    $3ca39a3e74eedadd$var$serializedNodeIds.set(node, serializeNodeId);
}
function $3ca39a3e74eedadd$export$9a014d2606da64f5(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */ const tagName = element.tagName;
    const value = element.value;
    if ((0, $82USe.shouldMaskNode)(element, nodePrivacyLevel)) {
        const type = element.type;
        if (tagName === "INPUT" && (type === "button" || type === "submit" || type === "reset")) // Overrule `MASK` privacy level for button-like element values, as they are used during replay
        // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
        return value;
        else if (!value || tagName === "OPTION") // <Option> value provides no benefit
        return;
        return 0, $82USe.CENSORED_STRING_MARK;
    }
    if (tagName === "OPTION" || tagName === "SELECT") return element.value;
    if (tagName !== "INPUT" && tagName !== "TEXTAREA") return;
    return value;
}
const $3ca39a3e74eedadd$export$ba314c99542e79a7 = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
const $3ca39a3e74eedadd$export$23a92ed48cea5444 = /^[A-Za-z]+:|^\/\//;
const $3ca39a3e74eedadd$export$dbafa72958753fce = /^["']?data:.*,/i;
function $3ca39a3e74eedadd$export$f7bc20cfc5b360e4(cssText, cssHref) {
    return cssText.replace($3ca39a3e74eedadd$export$ba314c99542e79a7, (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes)=>{
        const url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || $3ca39a3e74eedadd$export$23a92ed48cea5444.test(url) || $3ca39a3e74eedadd$export$dbafa72958753fce.test(url)) return matchingSubstring;
        const quote = singleQuote || doubleQuote || "";
        return `url(${quote}${$3ca39a3e74eedadd$var$makeUrlAbsolute(url, cssHref)}${quote})`;
    });
}
function $3ca39a3e74eedadd$var$makeUrlAbsolute(url, baseUrl) {
    try {
        return (0, $lCqoI.buildUrl)(url, baseUrl).href;
    } catch (_a) {
        return url;
    }
}
const $3ca39a3e74eedadd$var$TAG_NAME_REGEX = /[^a-z1-6-_]/;
function $3ca39a3e74eedadd$export$b3a58098b2e64dd6(tagName) {
    const processedTagName = tagName.toLowerCase().trim();
    if ($3ca39a3e74eedadd$var$TAG_NAME_REGEX.test(processedTagName)) // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return "div";
    return processedTagName;
}
function $3ca39a3e74eedadd$export$370a3fb2c1e85509(width, height) {
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' style='background-color:silver'%3E%3C/svg%3E`;
}

});

parcelRegister("b3Dw0", function(module, exports) {

$parcel$export(module.exports, "serializeDocument", function () { return $80cea067c111e0b9$export$6c4b5890a966884d; });

var $ak2xg = parcelRequire("ak2xg");

var $fti8b = parcelRequire("fti8b");

var $1vkMB = parcelRequire("1vkMB");
function $80cea067c111e0b9$export$6c4b5890a966884d(document, configuration, serializationContext) {
    const serializationStart = (0, $ak2xg.timeStampNow)();
    const serializedNode = (0, $fti8b.serializeNodeWithId)(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration
    });
    (0, $1vkMB.updateSerializationStats)(serializationContext.serializationStats, "serializationDuration", (0, $ak2xg.elapsed)(serializationStart, (0, $ak2xg.timeStampNow)()));
    // We are sure that Documents are never ignored, so this function never returns null
    return serializedNode;
}

});
parcelRegister("fti8b", function(module, exports) {

$parcel$export(module.exports, "serializeNodeWithId", function () { return $b437a0e161ffa11d$export$27792c824d895cd4; });

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $5cMnH = parcelRequire("5cMnH");

var $7MPqV = parcelRequire("7MPqV");

var $bvSMv = parcelRequire("bvSMv");
function $b437a0e161ffa11d$export$27792c824d895cd4(node, options) {
    const serializedNode = $b437a0e161ffa11d$var$serializeNode(node, options);
    if (!serializedNode) return null;
    // Try to reuse the previous id
    const id = (0, $5cMnH.getSerializedNodeId)(node) || $b437a0e161ffa11d$export$8ce4034bbb89f82a();
    const serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    (0, $5cMnH.setSerializedNodeId)(node, id);
    if (options.serializedNodeIds) options.serializedNodeIds.add(id);
    return serializedNodeWithId;
}
let $b437a0e161ffa11d$var$_nextId = 1;
function $b437a0e161ffa11d$export$8ce4034bbb89f82a() {
    return $b437a0e161ffa11d$var$_nextId++;
}
function $b437a0e161ffa11d$export$6cba1c3abeb370b2(node, options) {
    const result = [];
    (0, $82USe.forEachChildNodes)(node, (childNode)=>{
        const serializedChildNode = $b437a0e161ffa11d$export$27792c824d895cd4(childNode, options);
        if (serializedChildNode) result.push(serializedChildNode);
    });
    return result;
}
function $b437a0e161ffa11d$var$serializeNode(node, options) {
    switch(node.nodeType){
        case node.DOCUMENT_NODE:
            return $b437a0e161ffa11d$export$91525d3a437a6c5c(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return $b437a0e161ffa11d$var$serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return $b437a0e161ffa11d$var$serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return $b437a0e161ffa11d$var$serializeElementNode(node, options);
        case node.TEXT_NODE:
            return $b437a0e161ffa11d$var$serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return $b437a0e161ffa11d$var$serializeCDataNode();
    }
}
function $b437a0e161ffa11d$export$91525d3a437a6c5c(document, options) {
    return {
        type: (0, $tBEq8.NodeType).Document,
        childNodes: $b437a0e161ffa11d$export$6cba1c3abeb370b2(document, options),
        adoptedStyleSheets: (0, $7MPqV.serializeStyleSheets)(document.adoptedStyleSheets)
    };
}
function $b437a0e161ffa11d$var$serializeDocumentFragmentNode(element, options) {
    const isShadowRoot = (0, $82USe.isNodeShadowRoot)(element);
    if (isShadowRoot) options.serializationContext.shadowRootsController.addShadowRoot(element);
    return {
        type: (0, $tBEq8.NodeType).DocumentFragment,
        childNodes: $b437a0e161ffa11d$export$6cba1c3abeb370b2(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? (0, $7MPqV.serializeStyleSheets)(element.adoptedStyleSheets) : undefined
    };
}
function $b437a0e161ffa11d$var$serializeDocumentTypeNode(documentType) {
    return {
        type: (0, $tBEq8.NodeType).DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */ function $b437a0e161ffa11d$var$serializeElementNode(element, options) {
    const tagName = (0, $5cMnH.getValidTagName)(element.tagName);
    const isSVG = $b437a0e161ffa11d$var$isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    const nodePrivacyLevel = (0, $82USe.reducePrivacyLevel)((0, $82USe.getNodeSelfPrivacyLevel)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN) {
        const { width: width, height: height } = element.getBoundingClientRect();
        return {
            type: (0, $tBEq8.NodeType).Element,
            tagName: tagName,
            attributes: {
                rr_width: `${width}px`,
                rr_height: `${height}px`,
                [(0, $82USe.PRIVACY_ATTR_NAME)]: (0, $82USe.PRIVACY_ATTR_VALUE_HIDDEN)
            },
            childNodes: [],
            isSVG: isSVG
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).IGNORE) return;
    const attributes = (0, $bvSMv.serializeAttributes)(element, nodePrivacyLevel, options);
    let childNodes = [];
    if ((0, $82USe.hasChildNodes)(element) && // Do not serialize style children as the css rules are already in the _cssText attribute
    tagName !== "style") {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        let childNodesSerializationOptions;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === "head")) childNodesSerializationOptions = options;
        else childNodesSerializationOptions = {
            ...options,
            parentNodePrivacyLevel: nodePrivacyLevel,
            ignoreWhiteSpace: tagName === "head"
        };
        childNodes = $b437a0e161ffa11d$export$6cba1c3abeb370b2(element, childNodesSerializationOptions);
    }
    return {
        type: (0, $tBEq8.NodeType).Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG
    };
}
function $b437a0e161ffa11d$var$isSVGElement(el) {
    return el.tagName === "svg" || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */ function $b437a0e161ffa11d$var$serializeTextNode(textNode, options) {
    const textContent = (0, $82USe.getTextContent)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) return;
    return {
        type: (0, $tBEq8.NodeType).Text,
        textContent: textContent
    };
}
function $b437a0e161ffa11d$var$serializeCDataNode() {
    return {
        type: (0, $tBEq8.NodeType).CDATA,
        textContent: ""
    };
}

});
parcelRegister("7Z8vc", function(module, exports) {
$parcel$export(module.exports, "IncrementalSource", function () { return (parcelRequire("tBEq8")).IncrementalSource; });
$parcel$export(module.exports, "MediaInteractionType", function () { return (parcelRequire("tBEq8")).MediaInteractionType; });
$parcel$export(module.exports, "MouseInteractionType", function () { return (parcelRequire("tBEq8")).MouseInteractionType; });
$parcel$export(module.exports, "NodeType", function () { return (parcelRequire("tBEq8")).NodeType; });
$parcel$export(module.exports, "RecordType", function () { return (parcelRequire("tBEq8")).RecordType; });
parcelRequire("tBEq8");

});
parcelRegister("tBEq8", function(module, exports) {

$parcel$export(module.exports, "RecordType", function () { return $058fea3dd825c1f8$export$2edcab8dd1869daa; });
$parcel$export(module.exports, "NodeType", function () { return $058fea3dd825c1f8$export$f06e977173f1857c; });
$parcel$export(module.exports, "IncrementalSource", function () { return $058fea3dd825c1f8$export$24bb3ebc067ff5e1; });
$parcel$export(module.exports, "MouseInteractionType", function () { return $058fea3dd825c1f8$export$4e7964972bb3e05e; });
$parcel$export(module.exports, "MediaInteractionType", function () { return $058fea3dd825c1f8$export$df4c88b305317825; });
const $058fea3dd825c1f8$export$2edcab8dd1869daa = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9
};
const $058fea3dd825c1f8$export$f06e977173f1857c = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11
};
const $058fea3dd825c1f8$export$24bb3ebc067ff5e1 = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8
};
const $058fea3dd825c1f8$export$4e7964972bb3e05e = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9
};
const $058fea3dd825c1f8$export$df4c88b305317825 = {
    Play: 0,
    Pause: 1
};

});


parcelRegister("7MPqV", function(module, exports) {

$parcel$export(module.exports, "serializeStyleSheets", function () { return $5ab4e9af84c5e828$export$5426777f4276f7bf; });
function $5ab4e9af84c5e828$export$5426777f4276f7bf(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) return undefined;
    return cssStyleSheets.map((cssStyleSheet)=>{
        const rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        const cssRules = Array.from(rules, (cssRule)=>cssRule.cssText);
        const styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
        };
        return styleSheet;
    });
}

});

parcelRegister("bvSMv", function(module, exports) {

$parcel$export(module.exports, "serializeAttributes", function () { return $861d1561cb2294da$export$4954cae66e755861; });

var $82USe = parcelRequire("82USe");

var $eToVz = parcelRequire("eToVz");

var $5cMnH = parcelRequire("5cMnH");

var $eERII = parcelRequire("eERII");

var $1vkMB = parcelRequire("1vkMB");
function $861d1561cb2294da$export$4954cae66e755861(element, nodePrivacyLevel, options) {
    if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN) return {};
    const safeAttrs = {};
    const tagName = (0, $5cMnH.getValidTagName)(element.tagName);
    const doc = element.ownerDocument;
    for(let i = 0; i < element.attributes.length; i += 1){
        const attribute = element.attributes.item(i);
        const attributeName = attribute.name;
        const attributeValue = (0, $eERII.serializeAttribute)(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) safeAttrs[attributeName] = attributeValue;
    }
    if (element.value && (tagName === "textarea" || tagName === "select" || tagName === "option" || tagName === "input")) {
        const formValue = (0, $5cMnH.getElementInputValue)(element, nodePrivacyLevel);
        if (formValue !== undefined) safeAttrs.value = formValue;
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */ if (tagName === "option" && nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        const optionElement = element;
        if (optionElement.selected) safeAttrs.selected = optionElement.selected;
    }
    // remote css
    if (tagName === "link") {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>s.href === element.href);
        const cssText = $861d1561cb2294da$export$ef1cc196b0353a30(stylesheet);
        if (cssText && stylesheet) {
            (0, $1vkMB.updateSerializationStats)(options.serializationContext.serializationStats, "cssText", cssText.length);
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === "style" && element.sheet) {
        const cssText = $861d1561cb2294da$export$ef1cc196b0353a30(element.sheet);
        if (cssText) {
            (0, $1vkMB.updateSerializationStats)(options.serializationContext.serializationStats, "cssText", cssText.length);
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */ const inputElement = element;
    if (tagName === "input" && (inputElement.type === "radio" || inputElement.type === "checkbox")) {
        if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).ALLOW) safeAttrs.checked = !!inputElement.checked;
        else if ((0, $82USe.shouldMaskNode)(inputElement, nodePrivacyLevel)) delete safeAttrs.checked;
    }
    /**
     * Serialize the media playback state
     */ if (tagName === "audio" || tagName === "video") {
        const mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? "paused" : "played";
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */ let scrollTop;
    let scrollLeft;
    const serializationContext = options.serializationContext;
    switch(serializationContext.status){
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ :
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) serializationContext.elementsScrollPositions.set(element, {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ :
            if (serializationContext.elementsScrollPositions.has(element)) ({ scrollTop: scrollTop, scrollLeft: scrollLeft } = serializationContext.elementsScrollPositions.get(element));
            break;
    }
    if (scrollLeft) safeAttrs.rr_scrollLeft = scrollLeft;
    if (scrollTop) safeAttrs.rr_scrollTop = scrollTop;
    return safeAttrs;
}
function $861d1561cb2294da$export$ef1cc196b0353a30(cssStyleSheet) {
    if (!cssStyleSheet) return null;
    let rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) return null;
    const styleSheetCssText = Array.from(rules, (0, $eToVz.isSafari)() ? $861d1561cb2294da$var$getCssRuleStringForSafari : $861d1561cb2294da$var$getCssRuleString).join("");
    return (0, $5cMnH.switchToAbsoluteUrl)(styleSheetCssText, cssStyleSheet.href);
}
function $861d1561cb2294da$var$getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if ($861d1561cb2294da$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        const escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, "$1\\$2");
    }
    return $861d1561cb2294da$var$getCssRuleString(rule);
}
function $861d1561cb2294da$var$getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return $861d1561cb2294da$var$isCSSImportRule(rule) && $861d1561cb2294da$export$ef1cc196b0353a30(rule.styleSheet) || rule.cssText;
}
function $861d1561cb2294da$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $861d1561cb2294da$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}

});
parcelRegister("eERII", function(module, exports) {

$parcel$export(module.exports, "serializeAttribute", function () { return $aabe78cfe10a24c8$export$d36a50b4e4d32f1a; });

var $82USe = parcelRequire("82USe");

var $5cMnH = parcelRequire("5cMnH");
const $aabe78cfe10a24c8$export$60afd1bdd3673cde = 1000000;
function $aabe78cfe10a24c8$export$d36a50b4e4d32f1a(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN) // dup condition for direct access case
    return null;
    const attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).MASK && attributeName !== (0, $82USe.PRIVACY_ATTR_NAME) && !(0, $82USe.STABLE_ATTRIBUTES).includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
        const tagName = element.tagName;
        switch(attributeName){
            // Mask Attribute text content
            case "title":
            case "alt":
            case "placeholder":
                return 0, $82USe.CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === "IMG" && (attributeName === "src" || attributeName === "srcset")) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            const image = element;
            if (image.naturalWidth > 0) return (0, $5cMnH.censoredImageForSize)(image.naturalWidth, image.naturalHeight);
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width > 0 || height > 0) return (0, $5cMnH.censoredImageForSize)(width, height);
            // if we can't get the image size, fallback to the censored image
            return 0, $82USe.CENSORED_IMG_MARK;
        }
        // mask source URLs
        if (tagName === "SOURCE" && (attributeName === "src" || attributeName === "srcset")) return 0, $82USe.CENSORED_IMG_MARK;
        // mask <a> URLs
        if (tagName === "A" && attributeName === "href") return 0, $82USe.CENSORED_STRING_MARK;
        // mask data-* attributes
        if (attributeValue && attributeName.startsWith("data-")) // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
        return 0, $82USe.CENSORED_STRING_MARK;
        // mask iframe srcdoc
        if (tagName === "IFRAME" && attributeName === "srcdoc") return 0, $82USe.CENSORED_STRING_MARK;
    }
    if (!attributeValue || typeof attributeValue !== "string") return attributeValue;
    return (0, $82USe.sanitizeIfLongDataUrl)(attributeValue, $aabe78cfe10a24c8$export$60afd1bdd3673cde);
}

});

parcelRegister("1vkMB", function(module, exports) {

$parcel$export(module.exports, "createSerializationStats", function () { return $1188cec2adc7893e$export$9ddc873aa6a33b0b; });
$parcel$export(module.exports, "updateSerializationStats", function () { return $1188cec2adc7893e$export$d4996ef09d1d8577; });
$parcel$export(module.exports, "aggregateSerializationStats", function () { return $1188cec2adc7893e$export$4afe45942e407803; });
function $1188cec2adc7893e$export$9ddc873aa6a33b0b() {
    return {
        cssText: {
            count: 0,
            max: 0,
            sum: 0
        },
        serializationDuration: {
            count: 0,
            max: 0,
            sum: 0
        }
    };
}
function $1188cec2adc7893e$export$d4996ef09d1d8577(stats, metric, value) {
    stats[metric].count += 1;
    stats[metric].max = Math.max(stats[metric].max, value);
    stats[metric].sum += value;
}
function $1188cec2adc7893e$export$4afe45942e407803(aggregateStats, stats) {
    for (const metric of [
        "cssText",
        "serializationDuration"
    ]){
        aggregateStats[metric].count += stats[metric].count;
        aggregateStats[metric].max = Math.max(aggregateStats[metric].max, stats[metric].max);
        aggregateStats[metric].sum += stats[metric].sum;
    }
}

});





parcelRegister("7JhBz", function(module, exports) {

$parcel$export(module.exports, "isTouchEvent", function () { return $5a0a6459542a20c1$export$c4dfce035d43d1e0; });
$parcel$export(module.exports, "getEventTarget", function () { return $5a0a6459542a20c1$export$e58f029f0fbfdb29; });

var $82USe = parcelRequire("82USe");
function $5a0a6459542a20c1$export$c4dfce035d43d1e0(event) {
    return Boolean(event.changedTouches);
}
function $5a0a6459542a20c1$export$e58f029f0fbfdb29(event) {
    if (event.composed === true && (0, $82USe.isNodeShadowHost)(event.target)) return event.composedPath()[0];
    return event.target;
}

});

parcelRegister("jUJAc", function(module, exports) {

$parcel$export(module.exports, "convertMouseEventToLayoutCoordinates", function () { return $e7f69b192503abb1$export$eb47450612326c2; });
$parcel$export(module.exports, "getVisualViewport", function () { return $e7f69b192503abb1$export$27974520bd71cbc4; });
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */ // Scrollbar widths vary across properties on different devices and browsers
const $e7f69b192503abb1$var$TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */ function $e7f69b192503abb1$var$isVisualViewportFactoredIn(visualViewport) {
    return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > $e7f69b192503abb1$var$TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > $e7f69b192503abb1$var$TOLERANCE;
}
const $e7f69b192503abb1$export$eb47450612326c2 = (clientX, clientY)=>{
    const visualViewport = window.visualViewport;
    const normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY
    };
    if (!visualViewport) // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
    else if ($e7f69b192503abb1$var$isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    } else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
const $e7f69b192503abb1$export$27974520bd71cbc4 = (visualViewport)=>({
        scale: visualViewport.scale,
        offsetLeft: visualViewport.offsetLeft,
        offsetTop: visualViewport.offsetTop,
        pageLeft: visualViewport.pageLeft,
        pageTop: visualViewport.pageTop,
        height: visualViewport.height,
        width: visualViewport.width
    });

});

parcelRegister("jU43l", function(module, exports) {

$parcel$export(module.exports, "assembleIncrementalSnapshot", function () { return $e7d66417d7fe0587$export$8c66addc1bcc799e; });

var $ak2xg = parcelRequire("ak2xg");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
function $e7d66417d7fe0587$export$8c66addc1bcc799e(source, data) {
    return {
        data: {
            source: source,
            ...data
        },
        type: (0, $tBEq8.RecordType).IncrementalSnapshot,
        timestamp: (0, $ak2xg.timeStampNow)()
    };
}

});


parcelRegister("5OYfh", function(module, exports) {

$parcel$export(module.exports, "trackMouseInteraction", function () { return $43d05abb8ffcf1a1$export$9b708d0caac77d2e; });

var $la2h1 = parcelRequire("la2h1");

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $jU43l = parcelRequire("jU43l");

var $7JhBz = parcelRequire("7JhBz");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");

var $7PKCk = parcelRequire("7PKCk");
const $43d05abb8ffcf1a1$var$eventTypeToMouseInteraction = {
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    ["pointerup" /* DOM_EVENT.POINTER_UP */ ]: (0, $tBEq8.MouseInteractionType).MouseUp,
    ["mousedown" /* DOM_EVENT.MOUSE_DOWN */ ]: (0, $tBEq8.MouseInteractionType).MouseDown,
    ["click" /* DOM_EVENT.CLICK */ ]: (0, $tBEq8.MouseInteractionType).Click,
    ["contextmenu" /* DOM_EVENT.CONTEXT_MENU */ ]: (0, $tBEq8.MouseInteractionType).ContextMenu,
    ["dblclick" /* DOM_EVENT.DBL_CLICK */ ]: (0, $tBEq8.MouseInteractionType).DblClick,
    ["focus" /* DOM_EVENT.FOCUS */ ]: (0, $tBEq8.MouseInteractionType).Focus,
    ["blur" /* DOM_EVENT.BLUR */ ]: (0, $tBEq8.MouseInteractionType).Blur,
    ["touchstart" /* DOM_EVENT.TOUCH_START */ ]: (0, $tBEq8.MouseInteractionType).TouchStart,
    ["touchend" /* DOM_EVENT.TOUCH_END */ ]: (0, $tBEq8.MouseInteractionType).TouchEnd
};
function $43d05abb8ffcf1a1$export$9b708d0caac77d2e(configuration, mouseInteractionCb, recordIds) {
    const handler = (event)=>{
        const target = (0, $7JhBz.getEventTarget)(event);
        if ((0, $82USe.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $82USe.NodePrivacyLevel).HIDDEN || !(0, $5cMnH.hasSerializedNode)(target)) return;
        const id = (0, $5cMnH.getSerializedNodeId)(target);
        const type = $43d05abb8ffcf1a1$var$eventTypeToMouseInteraction[event.type];
        let interaction;
        if (type !== (0, $tBEq8.MouseInteractionType).Blur && type !== (0, $tBEq8.MouseInteractionType).Focus) {
            const coordinates = (0, $7PKCk.tryToComputeCoordinates)(event);
            if (!coordinates) return;
            interaction = {
                id: id,
                type: type,
                x: coordinates.x,
                y: coordinates.y
            };
        } else interaction = {
            id: id,
            type: type
        };
        const record = {
            id: recordIds.getIdForEvent(event),
            ...(0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).MouseInteraction, interaction)
        };
        mouseInteractionCb(record);
    };
    return (0, $la2h1.addEventListeners)(configuration, document, Object.keys($43d05abb8ffcf1a1$var$eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true
    });
}

});

parcelRegister("aZc9X", function(module, exports) {

$parcel$export(module.exports, "trackScroll", function () { return $7ff9088277486592$export$de1563ff5a1bae99; });

var $la2h1 = parcelRequire("la2h1");
var $k40sw = parcelRequire("k40sw");

var $82USe = parcelRequire("82USe");

var $7JhBz = parcelRequire("7JhBz");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $jU43l = parcelRequire("jU43l");
const $7ff9088277486592$var$SCROLL_OBSERVER_THRESHOLD = 100;
function $7ff9088277486592$export$de1563ff5a1bae99(configuration, scrollCb, elementsScrollPositions, target = document) {
    const { throttled: updatePosition, cancel: cancelThrottle } = (0, $k40sw.throttle)((event)=>{
        const target = (0, $7JhBz.getEventTarget)(event);
        if (!target || (0, $82USe.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $82USe.NodePrivacyLevel).HIDDEN || !(0, $5cMnH.hasSerializedNode)(target)) return;
        const id = (0, $5cMnH.getSerializedNodeId)(target);
        const scrollPositions = target === document ? {
            scrollTop: (0, $82USe.getScrollY)(),
            scrollLeft: (0, $82USe.getScrollX)()
        } : {
            scrollTop: Math.round(target.scrollTop),
            scrollLeft: Math.round(target.scrollLeft)
        };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).Scroll, {
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop
        }));
    }, $7ff9088277486592$var$SCROLL_OBSERVER_THRESHOLD);
    const { stop: removeListener } = (0, $la2h1.addEventListener)(configuration, target, "scroll" /* DOM_EVENT.SCROLL */ , updatePosition, {
        capture: true,
        passive: true
    });
    return {
        stop: ()=>{
            removeListener();
            cancelThrottle();
        }
    };
}

});

parcelRegister("cfOT6", function(module, exports) {

$parcel$export(module.exports, "trackViewportResize", function () { return $8ebe5bfb26f9a982$export$1b4a6a8302e2d23f; });
$parcel$export(module.exports, "trackVisualViewportResize", function () { return $8ebe5bfb26f9a982$export$23d8cfde1cc94c6f; });

var $la2h1 = parcelRequire("la2h1");
var $k40sw = parcelRequire("k40sw");
var $ak2xg = parcelRequire("ak2xg");

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $jUJAc = parcelRequire("jUJAc");

var $jU43l = parcelRequire("jU43l");
const $8ebe5bfb26f9a982$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function $8ebe5bfb26f9a982$export$1b4a6a8302e2d23f(configuration, viewportResizeCb) {
    const viewportResizeSubscription = (0, $82USe.initViewportObservable)(configuration).subscribe((data)=>{
        viewportResizeCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).ViewportResize, data));
    });
    return {
        stop: ()=>{
            viewportResizeSubscription.unsubscribe();
        }
    };
}
function $8ebe5bfb26f9a982$export$23d8cfde1cc94c6f(configuration, visualViewportResizeCb) {
    const visualViewport = window.visualViewport;
    if (!visualViewport) return {
        stop: (0, $k40sw.noop)
    };
    const { throttled: updateDimension, cancel: cancelThrottle } = (0, $k40sw.throttle)(()=>{
        visualViewportResizeCb({
            data: (0, $jUJAc.getVisualViewport)(visualViewport),
            type: (0, $tBEq8.RecordType).VisualViewport,
            timestamp: (0, $ak2xg.timeStampNow)()
        });
    }, $8ebe5bfb26f9a982$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false
    });
    const { stop: removeListener } = (0, $la2h1.addEventListeners)(configuration, visualViewport, [
        "resize" /* DOM_EVENT.RESIZE */ ,
        "scroll" /* DOM_EVENT.SCROLL */ 
    ], updateDimension, {
        capture: true,
        passive: true
    });
    return {
        stop: ()=>{
            removeListener();
            cancelThrottle();
        }
    };
}

});

parcelRegister("8TObS", function(module, exports) {

$parcel$export(module.exports, "trackMediaInteraction", function () { return $67aa64955afb96bc$export$400dbd5b48537196; });

var $la2h1 = parcelRequire("la2h1");

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $7JhBz = parcelRequire("7JhBz");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");

var $jU43l = parcelRequire("jU43l");
function $67aa64955afb96bc$export$400dbd5b48537196(configuration, mediaInteractionCb) {
    return (0, $la2h1.addEventListeners)(configuration, document, [
        "play" /* DOM_EVENT.PLAY */ ,
        "pause" /* DOM_EVENT.PAUSE */ 
    ], (event)=>{
        const target = (0, $7JhBz.getEventTarget)(event);
        if (!target || (0, $82USe.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $82USe.NodePrivacyLevel).HIDDEN || !(0, $5cMnH.hasSerializedNode)(target)) return;
        mediaInteractionCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).MediaInteraction, {
            id: (0, $5cMnH.getSerializedNodeId)(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */  ? (0, $tBEq8.MediaInteractionType).Play : (0, $tBEq8.MediaInteractionType).Pause
        }));
    }, {
        capture: true,
        passive: true
    });
}

});

parcelRegister("3EzVd", function(module, exports) {

$parcel$export(module.exports, "trackStyleSheet", function () { return $2a90f8d3ae8c8ee5$export$162cc50ed858c13d; });

var $4XGvV = parcelRequire("4XGvV");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");

var $jU43l = parcelRequire("jU43l");
function $2a90f8d3ae8c8ee5$export$162cc50ed858c13d(styleSheetCb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && (0, $5cMnH.hasSerializedNode)(styleSheet.ownerNode)) callback((0, $5cMnH.getSerializedNodeId)(styleSheet.ownerNode));
    }
    const instrumentationStoppers = [
        (0, $4XGvV.instrumentMethod)(CSSStyleSheet.prototype, "insertRule", ({ target: styleSheet, parameters: [rule, index] })=>{
            checkStyleSheetAndCallback(styleSheet, (id)=>styleSheetCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).StyleSheetRule, {
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: index
                        }
                    ]
                })));
        }),
        (0, $4XGvV.instrumentMethod)(CSSStyleSheet.prototype, "deleteRule", ({ target: styleSheet, parameters: [index] })=>{
            checkStyleSheetAndCallback(styleSheet, (id)=>styleSheetCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).StyleSheetRule, {
                    id: id,
                    removes: [
                        {
                            index: index
                        }
                    ]
                })));
        })
    ];
    if (typeof CSSGroupingRule !== "undefined") instrumentGroupingCSSRuleClass(CSSGroupingRule);
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0, $4XGvV.instrumentMethod)(cls.prototype, "insertRule", ({ target: styleSheet, parameters: [rule, index] })=>{
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, (id)=>{
                const path = $2a90f8d3ae8c8ee5$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index || 0);
                    styleSheetCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).StyleSheetRule, {
                        id: id,
                        adds: [
                            {
                                rule: rule,
                                index: path
                            }
                        ]
                    }));
                }
            });
        }), (0, $4XGvV.instrumentMethod)(cls.prototype, "deleteRule", ({ target: styleSheet, parameters: [index] })=>{
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, (id)=>{
                const path = $2a90f8d3ae8c8ee5$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index);
                    styleSheetCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).StyleSheetRule, {
                        id: id,
                        removes: [
                            {
                                index: path
                            }
                        ]
                    }));
                }
            });
        }));
    }
    return {
        stop: ()=>{
            instrumentationStoppers.forEach((stopper)=>stopper.stop());
        }
    };
}
function $2a90f8d3ae8c8ee5$export$5d7dd7838ad576e9(rule) {
    const path = [];
    let currentRule = rule;
    while(currentRule.parentRule){
        const rules = Array.from(currentRule.parentRule.cssRules);
        const index = rules.indexOf(currentRule);
        path.unshift(index);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) return;
    const rules = Array.from(currentRule.parentStyleSheet.cssRules);
    const index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}

});

parcelRegister("gkUlb", function(module, exports) {

$parcel$export(module.exports, "trackFocus", function () { return $be4a37ac8711a610$export$7d4f94d31d887582; });

var $la2h1 = parcelRequire("la2h1");
var $ak2xg = parcelRequire("ak2xg");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
function $be4a37ac8711a610$export$7d4f94d31d887582(configuration, focusCb) {
    return (0, $la2h1.addEventListeners)(configuration, window, [
        "focus" /* DOM_EVENT.FOCUS */ ,
        "blur" /* DOM_EVENT.BLUR */ 
    ], ()=>{
        focusCb({
            data: {
                has_focus: document.hasFocus()
            },
            type: (0, $tBEq8.RecordType).Focus,
            timestamp: (0, $ak2xg.timeStampNow)()
        });
    });
}

});

parcelRegister("eJj00", function(module, exports) {

$parcel$export(module.exports, "trackFrustration", function () { return $ab94017a42a5bfef$export$c3a8b90296cd71cc; });

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
function $ab94017a42a5bfef$export$c3a8b90296cd71cc(lifeCycle, frustrationCb, recordIds) {
    const frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , (data)=>{
        var _a, _b;
        if (data.rawRumEvent.type === (0, $82USe.RumEventType).ACTION && data.rawRumEvent.action.type === (0, $82USe.ActionType).CLICK && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && "events" in data.domainContext && data.domainContext.events && data.domainContext.events.length) frustrationCb({
            timestamp: data.rawRumEvent.date,
            type: (0, $tBEq8.RecordType).FrustrationRecord,
            data: {
                frustrationTypes: data.rawRumEvent.action.frustration.type,
                recordIds: data.domainContext.events.map((e)=>recordIds.getIdForEvent(e))
            }
        });
    });
    return {
        stop: ()=>{
            frustrationSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("42UAy", function(module, exports) {

$parcel$export(module.exports, "trackViewEnd", function () { return $2f233ea95b64596c$export$83ef897ea1b996ba; });

var $ak2xg = parcelRequire("ak2xg");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
function $2f233ea95b64596c$export$83ef897ea1b996ba(lifeCycle, viewEndCb) {
    const viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , ()=>{
        viewEndCb({
            timestamp: (0, $ak2xg.timeStampNow)(),
            type: (0, $tBEq8.RecordType).ViewEnd
        });
    });
    return {
        stop: ()=>{
            viewEndSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("jw2rs", function(module, exports) {

$parcel$export(module.exports, "trackInput", function () { return $e352e66593fa5df5$export$7ffba948d89b71d6; });

var $la2h1 = parcelRequire("la2h1");
var $4XGvV = parcelRequire("4XGvV");
var $k40sw = parcelRequire("k40sw");

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $7JhBz = parcelRequire("7JhBz");
parcelRequire("1ExgI");
var $5cMnH = parcelRequire("5cMnH");

var $jU43l = parcelRequire("jU43l");
function $e352e66593fa5df5$export$7ffba948d89b71d6(configuration, inputCb, target = document) {
    const defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    const lastInputStateMap = new WeakMap();
    const isShadowRoot = target !== document;
    const { stop: stopEventListeners } = (0, $la2h1.addEventListeners)(configuration, target, // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? [
        "change" /* DOM_EVENT.CHANGE */ 
    ] : [
        "input" /* DOM_EVENT.INPUT */ ,
        "change" /* DOM_EVENT.CHANGE */ 
    ], (event)=>{
        const target = (0, $7JhBz.getEventTarget)(event);
        if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) onElementChange(target);
    }, {
        capture: true,
        passive: true
    });
    let stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        const instrumentationStoppers = [
            (0, $4XGvV.instrumentSetter)(HTMLInputElement.prototype, "value", onElementChange),
            (0, $4XGvV.instrumentSetter)(HTMLInputElement.prototype, "checked", onElementChange),
            (0, $4XGvV.instrumentSetter)(HTMLSelectElement.prototype, "value", onElementChange),
            (0, $4XGvV.instrumentSetter)(HTMLTextAreaElement.prototype, "value", onElementChange),
            (0, $4XGvV.instrumentSetter)(HTMLSelectElement.prototype, "selectedIndex", onElementChange)
        ];
        stopPropertySetterInstrumentation = ()=>{
            instrumentationStoppers.forEach((stopper)=>stopper.stop());
        };
    } else stopPropertySetterInstrumentation = (0, $k40sw.noop);
    return {
        stop: ()=>{
            stopPropertySetterInstrumentation();
            stopEventListeners();
        }
    };
    function onElementChange(target) {
        const nodePrivacyLevel = (0, $82USe.getNodePrivacyLevel)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN) return;
        const type = target.type;
        let inputState;
        if (type === "radio" || type === "checkbox") {
            if ((0, $82USe.shouldMaskNode)(target, nodePrivacyLevel)) return;
            inputState = {
                isChecked: target.checked
            };
        } else {
            const value = (0, $5cMnH.getElementInputValue)(target, nodePrivacyLevel);
            if (value === undefined) return;
            inputState = {
                text: value
            };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        const name = target.name;
        if (type === "radio" && name && target.checked) document.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`).forEach((el)=>{
            if (el !== target) // TODO: Consider the privacy implications for various differing input privacy levels
            cbWithDedup(el, {
                isChecked: false
            });
        });
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */ function cbWithDedup(target, inputState) {
        if (!(0, $5cMnH.hasSerializedNode)(target)) return;
        const lastInputState = lastInputStateMap.get(target);
        if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            inputCb((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).Input, {
                id: (0, $5cMnH.getSerializedNodeId)(target),
                ...inputState
            }));
        }
    }
}

});

parcelRegister("eeW8V", function(module, exports) {

$parcel$export(module.exports, "trackMutation", function () { return $a5df79774e291851$export$24d76f013ec44d4c; });

var $ak2xg = parcelRequire("ak2xg");
var $9FcA5 = parcelRequire("9FcA5");
var $k40sw = parcelRequire("k40sw");

var $82USe = parcelRequire("82USe");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
parcelRequire("1ExgI");
var $1vkMB = parcelRequire("1vkMB");
var $5cMnH = parcelRequire("5cMnH");
var $eERII = parcelRequire("eERII");
var $fti8b = parcelRequire("fti8b");

var $gbxI8 = parcelRequire("gbxI8");

var $jU43l = parcelRequire("jU43l");
function $a5df79774e291851$export$24d76f013ec44d4c(mutationCallback, configuration, shadowRootsController, target) {
    const MutationObserver = (0, $82USe.getMutationObserverConstructor)();
    if (!MutationObserver) return {
        stop: (0, $k40sw.noop),
        flush: (0, $k40sw.noop)
    };
    const mutationBatch = (0, $gbxI8.createMutationBatch)((mutations)=>{
        $a5df79774e291851$var$processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    const observer = new MutationObserver((0, $9FcA5.monitor)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return {
        stop: ()=>{
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: ()=>{
            mutationBatch.flush();
        }
    };
}
function $a5df79774e291851$var$processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    const nodePrivacyLevelCache = new Map();
    mutations.filter((mutation)=>mutation.type === "childList").forEach((mutation)=>{
        mutation.removedNodes.forEach((removedNode)=>{
            $a5df79774e291851$var$traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    const filteredMutations = mutations.filter((mutation)=>mutation.target.isConnected && (0, $5cMnH.nodeAndAncestorsHaveSerializedNode)(mutation.target) && (0, $82USe.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== (0, $82USe.NodePrivacyLevel).HIDDEN);
    const serializationStats = (0, $1vkMB.createSerializationStats)();
    const { adds: adds, removes: removes, hasBeenSerialized: hasBeenSerialized } = $a5df79774e291851$var$processChildListMutations(filteredMutations.filter((mutation)=>mutation.type === "childList"), configuration, serializationStats, shadowRootsController, nodePrivacyLevelCache);
    const texts = $a5df79774e291851$var$processCharacterDataMutations(filteredMutations.filter((mutation)=>mutation.type === "characterData" && !hasBeenSerialized(mutation.target)), configuration, nodePrivacyLevelCache);
    const attributes = $a5df79774e291851$var$processAttributesMutations(filteredMutations.filter((mutation)=>mutation.type === "attributes" && !hasBeenSerialized(mutation.target)), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) return;
    mutationCallback((0, $jU43l.assembleIncrementalSnapshot)((0, $tBEq8.IncrementalSource).Mutation, {
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes
    }), serializationStats);
}
function $a5df79774e291851$var$processChildListMutations(mutations, configuration, serializationStats, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    const addedAndMovedNodes = new Set();
    const removedNodes = new Map();
    for (const mutation of mutations){
        mutation.addedNodes.forEach((node)=>{
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach((node)=>{
            if (!addedAndMovedNodes.has(node)) removedNodes.set(node, mutation.target);
            addedAndMovedNodes.delete(node);
        });
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    const sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    $a5df79774e291851$export$3060629b5781df1e(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    const serializedNodeIds = new Set();
    const serializationContext = {
        status: 2 /* SerializationContextStatus.MUTATION */ ,
        serializationStats: serializationStats,
        shadowRootsController: shadowRootsController
    };
    const addedNodeMutations = [];
    for (const node of sortedAddedAndMovedNodes){
        if (hasBeenSerialized(node)) continue;
        const parentNodePrivacyLevel = (0, $82USe.getNodePrivacyLevel)(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN || parentNodePrivacyLevel === (0, $82USe.NodePrivacyLevel).IGNORE) continue;
        const serializationStart = (0, $ak2xg.timeStampNow)();
        const serializedNode = (0, $fti8b.serializeNodeWithId)(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: serializationContext,
            configuration: configuration
        });
        (0, $1vkMB.updateSerializationStats)(serializationStats, "serializationDuration", (0, $ak2xg.elapsed)(serializationStart, (0, $ak2xg.timeStampNow)()));
        if (!serializedNode) continue;
        const parentNode = (0, $82USe.getParentNode)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: (0, $5cMnH.getSerializedNodeId)(parentNode),
            node: serializedNode
        });
    }
    // Finally, we emit remove mutations.
    const removedNodeMutations = [];
    removedNodes.forEach((parent, node)=>{
        if ((0, $5cMnH.hasSerializedNode)(node)) removedNodeMutations.push({
            parentId: (0, $5cMnH.getSerializedNodeId)(parent),
            id: (0, $5cMnH.getSerializedNodeId)(node)
        });
    });
    return {
        adds: addedNodeMutations,
        removes: removedNodeMutations,
        hasBeenSerialized: hasBeenSerialized
    };
    function hasBeenSerialized(node) {
        return (0, $5cMnH.hasSerializedNode)(node) && serializedNodeIds.has((0, $5cMnH.getSerializedNodeId)(node));
    }
    function getNextSibling(node) {
        let nextSibling = node.nextSibling;
        while(nextSibling){
            if ((0, $5cMnH.hasSerializedNode)(nextSibling)) return (0, $5cMnH.getSerializedNodeId)(nextSibling);
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function $a5df79774e291851$var$processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    const textMutations = [];
    // Deduplicate mutations based on their target node
    const handledNodes = new Set();
    const filteredMutations = mutations.filter((mutation)=>{
        if (handledNodes.has(mutation.target)) return false;
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (const mutation of filteredMutations){
        const value = mutation.target.textContent;
        if (value === mutation.oldValue) continue;
        const parentNodePrivacyLevel = (0, $82USe.getNodePrivacyLevel)((0, $82USe.getParentNode)(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $82USe.NodePrivacyLevel).HIDDEN || parentNodePrivacyLevel === (0, $82USe.NodePrivacyLevel).IGNORE) continue;
        textMutations.push({
            id: (0, $5cMnH.getSerializedNodeId)(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0, $82USe.getTextContent)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
        });
    }
    return textMutations;
}
function $a5df79774e291851$var$processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    const attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    const handledElements = new Map();
    const filteredMutations = mutations.filter((mutation)=>{
        const handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes && handledAttributes.has(mutation.attributeName)) return false;
        if (!handledAttributes) handledElements.set(mutation.target, new Set([
            mutation.attributeName
        ]));
        else handledAttributes.add(mutation.attributeName);
        return true;
    });
    // Emit mutations
    const emittedMutations = new Map();
    for (const mutation of filteredMutations){
        const uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) continue;
        const privacyLevel = (0, $82USe.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        const attributeValue = (0, $eERII.serializeAttribute)(mutation.target, privacyLevel, mutation.attributeName, configuration);
        let transformedValue;
        if (mutation.attributeName === "value") {
            const inputValue = (0, $5cMnH.getElementInputValue)(mutation.target, privacyLevel);
            if (inputValue === undefined) continue;
            transformedValue = inputValue;
        } else if (typeof attributeValue === "string") transformedValue = attributeValue;
        else transformedValue = null;
        let emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: (0, $5cMnH.getSerializedNodeId)(mutation.target),
                attributes: {}
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function $a5df79774e291851$export$3060629b5781df1e(nodes) {
    nodes.sort((a, b)=>{
        const position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */ if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) return -1;
        /* eslint-enable no-bitwise */ return 0;
    });
}
function $a5df79774e291851$var$traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0, $82USe.isNodeShadowHost)(removedNode)) shadowDomRemovedCallback(removedNode.shadowRoot);
    (0, $82USe.forEachChildNodes)(removedNode, (childNode)=>$a5df79774e291851$var$traverseRemovedShadowDom(childNode, shadowDomRemovedCallback));
}

});
parcelRegister("gbxI8", function(module, exports) {

$parcel$export(module.exports, "createMutationBatch", function () { return $030a72e1c33baa7b$export$b2ea3e1c9a968529; });

var $k40sw = parcelRequire("k40sw");
var $dZwHw = parcelRequire("dZwHw");
/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */ const $030a72e1c33baa7b$var$MUTATION_PROCESS_MAX_DELAY = 100;
const $030a72e1c33baa7b$export$3bd49c5ee28656ba = 16;
function $030a72e1c33baa7b$export$b2ea3e1c9a968529(processMutationBatch) {
    let cancelScheduledFlush = (0, $k40sw.noop);
    let pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    const { throttled: throttledFlush, cancel: cancelThrottle } = (0, $k40sw.throttle)(flush, $030a72e1c33baa7b$export$3bd49c5ee28656ba, {
        leading: false
    });
    return {
        addMutations: (mutations)=>{
            if (pendingMutations.length === 0) cancelScheduledFlush = (0, $dZwHw.requestIdleCallback)(throttledFlush, {
                timeout: $030a72e1c33baa7b$var$MUTATION_PROCESS_MAX_DELAY
            });
            pendingMutations.push(...mutations);
        },
        flush: flush,
        stop: ()=>{
            cancelScheduledFlush();
            cancelThrottle();
        }
    };
}

});



parcelRegister("dX2go", function(module, exports) {

$parcel$export(module.exports, "createElementsScrollPositions", function () { return $a2828a878a7a8bbe$export$e1169a2914f55ec7; });
function $a2828a878a7a8bbe$export$e1169a2914f55ec7() {
    const scrollPositionsByElement = new WeakMap();
    return {
        set (element, scrollPositions) {
            if (element === document && !document.scrollingElement) // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
            // in some cases scrolling elements can not be defined, we don't support those for now
            return;
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get (element) {
            return scrollPositionsByElement.get(element);
        },
        has (element) {
            return scrollPositionsByElement.has(element);
        }
    };
}

});

parcelRegister("lnrcK", function(module, exports) {

$parcel$export(module.exports, "initShadowRootsController", function () { return $f900d93b67115107$export$436c949d161d53cc; });
parcelRequire("1khYs");
var $jw2rs = parcelRequire("jw2rs");
var $eeW8V = parcelRequire("eeW8V");
var $aZc9X = parcelRequire("aZc9X");
const $f900d93b67115107$export$436c949d161d53cc = (configuration, callback, elementsScrollPositions)=>{
    const controllerByShadowRoot = new Map();
    const shadowRootsController = {
        addShadowRoot: (shadowRoot)=>{
            if (controllerByShadowRoot.has(shadowRoot)) return;
            const mutationTracker = (0, $eeW8V.trackMutation)(callback, configuration, shadowRootsController, shadowRoot);
            // The change event does not bubble up across the shadow root, we have to listen on the shadow root
            const inputTracker = (0, $jw2rs.trackInput)(configuration, callback, shadowRoot);
            // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
            const scrollTracker = (0, $aZc9X.trackScroll)(configuration, callback, elementsScrollPositions, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: ()=>mutationTracker.flush(),
                stop: ()=>{
                    mutationTracker.stop();
                    inputTracker.stop();
                    scrollTracker.stop();
                }
            });
        },
        removeShadowRoot: (shadowRoot)=>{
            const entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
            return;
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: ()=>{
            controllerByShadowRoot.forEach(({ stop: stop })=>stop());
        },
        flush: ()=>{
            controllerByShadowRoot.forEach(({ flush: flush })=>flush());
        }
    };
    return shadowRootsController;
};

});

parcelRegister("12bW4", function(module, exports) {

$parcel$export(module.exports, "startFullSnapshots", function () { return $0c0f3c82288c793d$export$4955b6cdd7723991; });

var $82USe = parcelRequire("82USe");

var $ak2xg = parcelRequire("ak2xg");
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");
parcelRequire("1ExgI");
var $1vkMB = parcelRequire("1vkMB");
var $b3Dw0 = parcelRequire("b3Dw0");

var $jUJAc = parcelRequire("jUJAc");
function $0c0f3c82288c793d$export$4955b6cdd7723991(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, emit) {
    const takeFullSnapshot = (timestamp, status)=>{
        const { width: width, height: height } = (0, $82USe.getViewportDimension)();
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width
            },
            type: (0, $tBEq8.RecordType).Meta,
            timestamp: timestamp
        });
        emit({
            data: {
                has_focus: document.hasFocus()
            },
            type: (0, $tBEq8.RecordType).Focus,
            timestamp: timestamp
        });
        const serializationStats = (0, $1vkMB.createSerializationStats)();
        const serializationContext = {
            status: status,
            elementsScrollPositions: elementsScrollPositions,
            serializationStats: serializationStats,
            shadowRootsController: shadowRootsController
        };
        emit({
            data: {
                node: (0, $b3Dw0.serializeDocument)(document, configuration, serializationContext),
                initialOffset: {
                    left: (0, $82USe.getScrollX)(),
                    top: (0, $82USe.getScrollY)()
                }
            },
            type: (0, $tBEq8.RecordType).FullSnapshot,
            timestamp: timestamp
        }, serializationStats);
        if (window.visualViewport) emit({
            data: (0, $jUJAc.getVisualViewport)(window.visualViewport),
            type: (0, $tBEq8.RecordType).VisualViewport,
            timestamp: timestamp
        });
    };
    takeFullSnapshot((0, $ak2xg.timeStampNow)(), 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ );
    const { unsubscribe: unsubscribe } = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */ , (view)=>{
        flushMutations();
        takeFullSnapshot(view.startClocks.timeStamp, 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ );
    });
    return {
        stop: unsubscribe
    };
}

});

parcelRegister("eabLN", function(module, exports) {

$parcel$export(module.exports, "initRecordIds", function () { return $a4fb212087c85911$export$9a1e4d732092db82; });
function $a4fb212087c85911$export$9a1e4d732092db82() {
    const recordIds = new WeakMap();
    let nextId = 1;
    return {
        getIdForEvent (event) {
            if (!recordIds.has(event)) recordIds.set(event, nextId++);
            return recordIds.get(event);
        }
    };
}

});



parcelRegister("lDilv", function(module, exports) {

$parcel$export(module.exports, "startSegmentCollection", function () { return (parcelRequire("5RW20")).startSegmentCollection; });
$parcel$export(module.exports, "SEGMENT_BYTES_LIMIT", function () { return (parcelRequire("5RW20")).SEGMENT_BYTES_LIMIT; });
$parcel$export(module.exports, "startSegmentTelemetry", function () { return (parcelRequire("hdBNW")).startSegmentTelemetry; });

var $5RW20 = parcelRequire("5RW20");

var $hdBNW = parcelRequire("hdBNW");

});
parcelRegister("5RW20", function(module, exports) {

$parcel$export(module.exports, "SEGMENT_BYTES_LIMIT", function () { return $445eeacbbdc41e1a$export$498b4a5e1a0c6ede; });
$parcel$export(module.exports, "startSegmentCollection", function () { return $445eeacbbdc41e1a$export$4fa4acf70ad1cce9; });

var $las6Q = parcelRequire("las6Q");
var $erNjC = parcelRequire("erNjC");
var $ak2xg = parcelRequire("ak2xg");

var $gBeFp = parcelRequire("gBeFp");

var $69OtX = parcelRequire("69OtX");
const $445eeacbbdc41e1a$export$b31f220778239113 = 5 * (0, $ak2xg.ONE_SECOND);
let $445eeacbbdc41e1a$export$498b4a5e1a0c6ede = 60000;
function $445eeacbbdc41e1a$export$4fa4acf70ad1cce9(lifeCycle, configuration, sessionManager, viewHistory, httpRequest, encoder) {
    return $445eeacbbdc41e1a$export$a72587c29e6a171e(lifeCycle, ()=>$445eeacbbdc41e1a$export$ffabacd17e6fd35a(configuration.applicationId, sessionManager, viewHistory), httpRequest, encoder);
}
function $445eeacbbdc41e1a$export$a72587c29e6a171e(lifeCycle, getSegmentContext, httpRequest, encoder) {
    let state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
        nextSegmentCreationReason: "init"
    };
    const { unsubscribe: unsubscribeViewCreated } = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */ , ()=>{
        flushSegment("view_change");
    });
    const { unsubscribe: unsubscribePageMayExit } = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , (pageMayExitEvent)=>{
        flushSegment(pageMayExitEvent.reason);
    });
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */ ) {
            state.segment.flush((metadata, stats, encoderResult)=>{
                const payload = (0, $gBeFp.buildReplayPayload)(encoderResult.output, metadata, stats, encoderResult.rawBytesCount);
                if ((0, $erNjC.isPageExitReason)(flushReason)) httpRequest.sendOnExit(payload);
                else httpRequest.send(payload);
            });
            (0, $las6Q.clearTimeout)(state.expirationTimeoutId);
        }
        if (flushReason !== "stop") state = {
            status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
            nextSegmentCreationReason: flushReason
        };
        else state = {
            status: 2 /* SegmentCollectionStatus.Stopped */ 
        };
    }
    return {
        addRecord: (record, stats)=>{
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */ ) return;
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ) {
                const context = getSegmentContext();
                if (!context) return;
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */ ,
                    segment: (0, $69OtX.createSegment)({
                        encoder: encoder,
                        context: context,
                        creationReason: state.nextSegmentCreationReason
                    }),
                    expirationTimeoutId: (0, $las6Q.setTimeout)(()=>{
                        flushSegment("segment_duration_limit");
                    }, $445eeacbbdc41e1a$export$b31f220778239113)
                };
            }
            state.segment.addRecord(record, stats, (encodedBytesCount)=>{
                if (encodedBytesCount > $445eeacbbdc41e1a$export$498b4a5e1a0c6ede) flushSegment("segment_bytes_limit");
            });
        },
        stop: ()=>{
            flushSegment("stop");
            unsubscribeViewCreated();
            unsubscribePageMayExit();
        }
    };
}
function $445eeacbbdc41e1a$export$ffabacd17e6fd35a(applicationId, sessionManager, viewHistory) {
    const session = sessionManager.findTrackedSession();
    const viewContext = viewHistory.findView();
    if (!session || !viewContext) return undefined;
    return {
        application: {
            id: applicationId
        },
        session: {
            id: session.id
        },
        view: {
            id: viewContext.id
        }
    };
}
function $445eeacbbdc41e1a$export$fabe14a3439e20b(newSegmentBytesLimit = 60000) {
    $445eeacbbdc41e1a$export$498b4a5e1a0c6ede = newSegmentBytesLimit;
}

});
parcelRegister("gBeFp", function(module, exports) {

$parcel$export(module.exports, "buildReplayPayload", function () { return $c15b7a92b57a200a$export$b74fe9b7c5190a03; });
function $c15b7a92b57a200a$export$b74fe9b7c5190a03(data, metadata, stats, rawSegmentBytesCount) {
    const formData = new FormData();
    formData.append("segment", new Blob([
        data
    ], {
        type: "application/octet-stream"
    }), `${metadata.session.id}-${metadata.start}`);
    const metadataAndSegmentSizes = {
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
        ...metadata
    };
    const serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append("event", new Blob([
        serializedMetadataAndSegmentSizes
    ], {
        type: "application/json"
    }));
    return {
        data: formData,
        bytesCount: data.byteLength,
        cssText: stats.cssText,
        isFullSnapshot: metadata.index_in_view === 0,
        rawSize: rawSegmentBytesCount,
        recordCount: metadata.records_count,
        serializationDuration: stats.serializationDuration
    };
}

});

parcelRegister("69OtX", function(module, exports) {

$parcel$export(module.exports, "createSegment", function () { return $47babe0f40691976$export$a3c3648560d43a8; });
parcelRequire("7Z8vc");
var $tBEq8 = parcelRequire("tBEq8");

var $jVAvF = parcelRequire("jVAvF");
parcelRequire("bjWjO");
var $1vkMB = parcelRequire("1vkMB");
function $47babe0f40691976$export$a3c3648560d43a8({ context: context, creationReason: creationReason, encoder: encoder }) {
    let encodedBytesCount = 0;
    const viewId = context.view.id;
    const indexInView = $jVAvF.getSegmentsCount(viewId);
    const metadata = {
        start: Infinity,
        end: -Infinity,
        creation_reason: creationReason,
        records_count: 0,
        has_full_snapshot: false,
        index_in_view: indexInView,
        source: "browser",
        ...context
    };
    const serializationStats = (0, $1vkMB.createSerializationStats)();
    $jVAvF.addSegment(viewId);
    function addRecord(record, stats, callback) {
        metadata.start = Math.min(metadata.start, record.timestamp);
        metadata.end = Math.max(metadata.end, record.timestamp);
        metadata.records_count += 1;
        metadata.has_full_snapshot || (metadata.has_full_snapshot = record.type === (0, $tBEq8.RecordType).FullSnapshot);
        if (stats) (0, $1vkMB.aggregateSerializationStats)(serializationStats, stats);
        const prefix = encoder.isEmpty ? '{"records":[' : ",";
        encoder.write(prefix + JSON.stringify(record), (additionalEncodedBytesCount)=>{
            encodedBytesCount += additionalEncodedBytesCount;
            callback(encodedBytesCount);
        });
    }
    function flush(callback) {
        if (encoder.isEmpty) throw new Error("Empty segment flushed");
        encoder.write(`],${JSON.stringify(metadata).slice(1)}\n`);
        encoder.finish((encoderResult)=>{
            $jVAvF.addWroteData(metadata.view.id, encoderResult.rawBytesCount);
            callback(metadata, serializationStats, encoderResult);
        });
    }
    return {
        addRecord: addRecord,
        flush: flush
    };
}

});


parcelRegister("hdBNW", function(module, exports) {

$parcel$export(module.exports, "startSegmentTelemetry", function () { return $c890f9bfdf546df3$export$65c37e1a6de5b471; });

var $d5Gi4 = parcelRequire("d5Gi4");
var $k40sw = parcelRequire("k40sw");
var $6Zl8B = parcelRequire("6Zl8B");
const $c890f9bfdf546df3$var$SEGMENT_METRICS_TELEMETRY_NAME = "Segment network request metrics";
function $c890f9bfdf546df3$export$65c37e1a6de5b471(configuration, telemetry, requestObservable) {
    const segmentTelemetryEnabled = telemetry.enabled && (0, $6Zl8B.performDraw)(configuration.replayTelemetrySampleRate);
    if (!segmentTelemetryEnabled) return {
        stop: (0, $k40sw.noop)
    };
    const { unsubscribe: unsubscribe } = requestObservable.subscribe((requestEvent)=>{
        if (requestEvent.type === "failure" || requestEvent.type === "queue-full" || requestEvent.type === "success" && requestEvent.payload.isFullSnapshot) {
            const metrics = $c890f9bfdf546df3$var$createSegmentMetrics(requestEvent.type, requestEvent.bandwidth, requestEvent.payload);
            (0, $d5Gi4.addTelemetryMetrics)($c890f9bfdf546df3$var$SEGMENT_METRICS_TELEMETRY_NAME, {
                metrics: metrics
            });
        }
    });
    return {
        stop: unsubscribe
    };
}
function $c890f9bfdf546df3$var$createSegmentMetrics(result, bandwidthStats, payload) {
    return {
        cssText: {
            count: payload.cssText.count,
            max: payload.cssText.max,
            sum: payload.cssText.sum
        },
        isFullSnapshot: payload.isFullSnapshot,
        ongoingRequests: {
            count: bandwidthStats.ongoingRequestCount,
            totalSize: bandwidthStats.ongoingByteCount
        },
        recordCount: payload.recordCount,
        result: result,
        serializationDuration: {
            count: payload.serializationDuration.count,
            max: payload.serializationDuration.max,
            sum: payload.serializationDuration.sum
        },
        size: {
            compressed: payload.bytesCount,
            raw: payload.rawSize
        }
    };
}

});


parcelRegister("kJtyc", function(module, exports) {

$parcel$export(module.exports, "startRecordBridge", function () { return $f17eeebfdd8a57ba$export$f4759b712f6b3c83; });

var $iwN6C = parcelRequire("iwN6C");
function $f17eeebfdd8a57ba$export$f4759b712f6b3c83(viewHistory) {
    const bridge = (0, $iwN6C.getEventBridge)();
    return {
        addRecord: (record)=>{
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            const view = viewHistory.findView();
            bridge.send("record", record, view.id);
        }
    };
}

});


})();
//# sourceMappingURL=startRecording.cef8cf2c.js.map
